import React from 'react';
import { Link } from 'react-router-dom';
import { categories } from '../data/categories';
import { Facebook, Instagram } from 'lucide-react';
// Custom X (formerly Twitter) icon
function XIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className} data-id="element-90">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" data-id="element-91" />
    </svg>;
}
// Custom TikTok icon
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className} data-id="element-92">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.94a8.16 8.16 0 0 0 4.77 1.52V7.05a4.78 4.78 0 0 1-1.84-.36z" data-id="element-93" />
    </svg>;
}
export function Footer() {
  return <footer className="bg-white border-t border-gray-200 pt-12 pb-8" data-id="element-94">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-96">
          <div className="col-span-1 md:col-span-1" data-id="element-97">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-98">
              <div className="w-8 h-8 rounded bg-red-100 flex items-center justify-center text-red-600 font-bold text-xl" data-id="element-99">
                B
              </div>
              <span className="font-bold text-xl text-gray-900 tracking-tight" data-id="element-100">
                Beach Shop
              </span>
            </Link>
            <p className="text-gray-500 text-sm mb-4" data-id="element-101">
              Beachwear and accessories for summer holidays. Your one-stop shop
              for everything you need under the sun.
            </p>
            <div className="flex space-x-4" data-id="element-102">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-103">
                <span className="sr-only" data-id="element-104">Facebook</span>
                <Facebook className="h-5 w-5" data-id="element-105" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-106">
                <span className="sr-only" data-id="element-107">Instagram</span>
                <Instagram className="h-5 w-5" data-id="element-108" />
              </a>
              <a href="https://x.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-109">
                <span className="sr-only" data-id="element-110">X</span>
                <XIcon className="h-5 w-5" data-id="element-111" />
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-112">
                <span className="sr-only" data-id="element-113">TikTok</span>
                <TikTokIcon className="h-5 w-5" data-id="element-114" />
              </a>
            </div>
          </div>

          <div data-id="element-115">
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-4" data-id="element-116">
              Shop
            </h3>
            <ul className="space-y-3" data-id="element-117">
              <li data-id="element-118">
                <Link to="/shop" className="text-sm text-gray-500 hover:text-red-600" data-id="element-119">
                  All Products
                </Link>
              </li>
              {categories.map(cat => <li key={cat.id} data-id="element-120">
                  <Link to={`/shop/${cat.id}`} className="text-sm text-gray-500 hover:text-red-600" data-id="element-121">
                    {cat.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div data-id="element-122">
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-4" data-id="element-123">
              Support
            </h3>
            <ul className="space-y-3" data-id="element-124">
              <li data-id="element-125">
                <Link to="/contact" className="text-sm text-gray-500 hover:text-red-600" data-id="element-126">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-127">
                <Link to="/faq" className="text-sm text-gray-500 hover:text-red-600" data-id="element-128">
                  FAQ
                </Link>
              </li>
              <li data-id="element-129">
                <Link to="/shipping" className="text-sm text-gray-500 hover:text-red-600" data-id="element-130">
                  Shipping & Returns
                </Link>
              </li>
              <li data-id="element-131">
                <Link to="/track-order" className="text-sm text-gray-500 hover:text-red-600" data-id="element-132">
                  Track Order
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-133">
            <h3 className="text-sm font-semibold text-gray-900 tracking-wider uppercase mb-4" data-id="element-134">
              Secure Payment
            </h3>
            <p className="text-sm text-gray-500 mb-4" data-id="element-135">
              We process all payments securely through the Bank of Maldives
              payment gateway.
            </p>
            <div className="bg-white border border-gray-200 rounded-lg p-3 flex items-center gap-3 w-max shadow-sm" data-id="element-136">
              <img src="https://cdn.magicpatterns.com/uploads/2e3rWSAHwSB4NuxAx1sgGW/Logo_of_Bank_of_Maldives.svg.png" alt="Bank of Maldives" className="w-10 h-10 object-contain" data-id="element-137" />
              <div data-id="element-138">
                <div className="text-xs font-semibold text-gray-900" data-id="element-139">
                  Bank of Maldives
                </div>
                <div className="text-[10px] text-gray-500" data-id="element-140">Secure Gateway</div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-141">
          <p className="text-sm text-gray-400" data-id="element-142">
            &copy; {new Date().getFullYear()} Beach Shop Maldives. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-143">
            <Link to="/privacy" className="text-sm text-gray-400 hover:text-gray-900" data-id="element-144">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm text-gray-400 hover:text-gray-900" data-id="element-145">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}